import { Component, OnDestroy, OnInit } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType } from '@azure/msal-browser';
import { MonitoringService } from '@core/services/monitoring.service';
import { AuthenticationService } from '@core/authentication/auth.service';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'spark-core-login-failed',
  templateUrl: './login-failed.component.html',
  styleUrls: ['./login-failed.component.scss']
})
export class LoginFailedComponent implements OnInit, OnDestroy {
  constructor(
    private msalBroadcastService: MsalBroadcastService, 
    private msalAuthService: MsalService,
    private monitoringService: MonitoringService,
    private authService: AuthenticationService
  ) {}
  
  private subscription!: Subscription;
  public isRetrying: boolean = false;
  
  ngOnInit(): void {
    this.subscription = this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_FAILURE),
      )
      .subscribe((result: EventMessage) => {
        if (result.error != null)
          this.monitoringService.logTrace("Redirected to login-failed with error ", { event: result.eventType, error: result.error });
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * Retry login by clearing cache and logging out (cleanest recovery approach)
   * Selectively clears only MSAL authentication keys, preserving user preferences
   */
  public retry(): void {
    this.isRetrying = true;
    this.monitoringService.logTrace("User initiated retry from login-failed page - selectively clearing MSAL cache and logging out");
    
    // Selectively clear only MSAL-related keys from localStorage and sessionStorage
    this.authService.clearMsalStorage();
    
    // Logout redirect - will clear MSAL state and redirect to login
    this.msalAuthService.instance.logoutRedirect({
      postLogoutRedirectUri: '/'
    });
  }
}